import $http from "../http";

//获取部门树
export const getTreeUnitList = data => {
    return $http.post("/collect/tree_unit/getTreeUnitList", data);
};

//保存部门树
export const saveTreeUnit = data => {
    return $http.post("/collect/tree_unit/saveTreeUnit", data);
};

//删除部门树
export const delUnit = data => {
    return $http.post("/collect/tree_unit/del", data);
};

//公式保存
export const saveExpress = data => {
    return $http.post("/collect/tree_unit/save", data);
};

//根据ID查询公式
export const getTreeUnitById = data => {
    return $http.post("/collect/tree_unit/getTreeUnitById", data);
};
